import { render, staticRenderFns } from "./assessmentVersion.vue?vue&type=template&id=d6c7e976&scoped=true&"
import script from "./assessmentVersion.vue?vue&type=script&lang=js&"
export * from "./assessmentVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c7e976",
  null
  
)

export default component.exports